import {Injectable} from '@angular/core';
import {AbstractControl, UntypedFormGroup} from '@angular/forms';

@Injectable({providedIn: 'root'})
export class ValidationService {
  constructor() {
  }

  showWarning(formGroup: UntypedFormGroup, controlName: string, isShowWarning: boolean) {
    return !formGroup.get(controlName).valid && isShowWarning;
  }

  checkRequired(formGroup: UntypedFormGroup, controlName: string, isFormEditable: boolean, isshowWarning: boolean) {
    const element = formGroup.get(controlName);
    return element.hasError('required') && isshowWarning;
  }

  checkMaxLength(formGroup: UntypedFormGroup, controlName: string) {
    const element = formGroup.get(controlName);
    return element.hasError('maxlength') && element.dirty;
  }

  showMaxLengthErrorMessage(formGroup: UntypedFormGroup, controlName: string) {
    const requiredLength = formGroup.get(controlName).getError('maxlength').requiredLength;
    const formattedNumber = requiredLength.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return 'Please enter less than ' + formattedNumber + ' characters';
  }

  isFormValid(formGroup: UntypedFormGroup): boolean {
    // check only if form has max length errors, ignore required for disabling submit
    let isValid = true;

    const controlNames = Object.keys(formGroup.controls);

    for (let i = 0; i < controlNames.length; i++) {
      const control: AbstractControl = formGroup.get(controlNames[i]);

      if (control.errors && control.errors.maxlength && control.dirty) {
        isValid = false;
        break;
      }
    }

    return isValid;
  }
}
